export const formatPostalCode = (inputString: string) => {
        // Helper function to check if a string is alphanumeric
        function isAlphanumeric(str: string): boolean {
            return /^[a-zA-Z0-9]+$/.test(str);
        }

        // Helper function to check if a string is numeric only
        function isNumeric(str: string): boolean {
            return /^\d+$/.test(str);
        }

        // Helper function to check if a string contains any alphabet
        function containsAlphabet(str: string): boolean {
            return /[a-zA-Z]/.test(str);
        }
        function allAlphabets(str: string): boolean {
            return /^[A-Za-z]+$/.test(str);
        }

        // // If the string is numeric, return it as is
        if (isNumeric(inputString)) {
            return inputString;
        }

        // If the string is alphanumeric and has no space in the 4th position
        if (isAlphanumeric(inputString) && !allAlphabets(inputString) && inputString.length > 3 && inputString[3] !== ' ') {
            return `${inputString.slice(0, 3)} ${inputString.slice(3)}`;
        }

        if ((inputString.length > 3 && inputString[3] === ' ' && isNumeric(inputString.replace(' ', ''))) || allAlphabets(inputString.replace(' ', ''))) {
            return inputString.replace(' ', '');
        }


        return inputString;
    
};
